import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { sectorService, SectorPage } from './sector-service'
import { toast } from 'sonner'

export const useSectorPage = () => {
    const queryClient = useQueryClient()

    const sectorPageQuery = useQuery({
        queryKey: ['sector-page'],
        queryFn: sectorService.getSectorPage
    })

    const updateSectorPageMutation = useMutation({
        mutationFn: ({ data, translate }: { data: Partial<SectorPage>; translate?: boolean }) =>
            sectorService.updateSectorPage(data, translate),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['sector-page'] })
            toast.success('Sektör sayfası başarıyla güncellendi.')
        },
        onError: (error: any) => {
            toast.error('Sektör sayfası güncellenirken bir hata oluştu: ' + error.message)
        }
    })

    return {
        sectorPageQuery,
        updateSectorPageMutation
    }
}
